import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import { selectCalloutBanner } from '@redux/globalSlice'
import clsx from 'clsx'
import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { Autoplay } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from './CalloutBanner.module.scss'

type CalloutBannerProps = {}

const CalloutBanner: FC<CalloutBannerProps> = () => {
  const calloutBanner = useSelector(selectCalloutBanner)
  const [swiperInit, setSwiperInit] = useState(false)

  const calloutBannerContent = (
    <div
      className={clsx(styles.swiperContainer, {
        [styles.show]: swiperInit,
      })}
    >
      <Swiper
        loop={calloutBanner?.texts && calloutBanner.texts.length > 1}
        slidesPerView={1}
        autoplay={{ delay: calloutBanner?.timePerSlide ?? 2000 }}
        modules={[Autoplay]}
        className={styles.root}
        onAfterInit={() => {
          setSwiperInit(true)
        }}
      >
        {calloutBanner?.texts &&
          calloutBanner?.texts.map(({ text }: any, index) => {
            return (
              <SwiperSlide key={index}>
                <TrustedHtml
                  html={text}
                  className="relative  px-0 justify-center items-center flex w-full !max-w-full "
                />
              </SwiperSlide>
            )
          })}
      </Swiper>
    </div>
  )
  const ttt = (
    <>
      {calloutBanner?.texts &&
        calloutBanner?.texts.map(({ text }: any, index) => (
          <TrustedHtml
            html={text}
            key={index}
            className="flex justify-center"
          />
        ))}
    </>
  )
  return calloutBanner?.texts.length > 1 ? (
    <>
      <div className={clsx(styles.container, styles.mobile)}>
        {calloutBannerContent}
      </div>

      <div className={clsx(styles.container, styles.desktop)}>{ttt}</div>
    </>
  ) : (
    <></>
  )
}

export default CalloutBanner
